import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { routerReducer } from "react-router-redux";

// Reducers
import queuesReducer from "./Queues/redux";
import eventsReducer, { EventsState } from "./Events/redux";
import messageReducer from "./Messages/reducer";
import modalsReducer from "./Modals/reducer";

import {
  OperatorDashboardStateShape,
  underwriterDashboardReducer,
} from "./underwriter_dashboard/reducer";
import worksheetEditorReducer from "./underwriter_dashboard/shared/WorksheetEditor/reducer";
import trusOperatorsReducer from "./redux/getTrusOperators/reducer";

// HLHL Contacts
import hlhlContactsRoleReducer from "./shared/LoggedInContainer/reducer";

// Types
import { PENDING_SEND_MESSAGE_SUCCESS } from "./Messages/types";
import { GetTRUSOperatorsState } from "./redux/getTrusOperators/types";

/* TODO: move to borrower-specific module and then import/combine */

import Action from "./Action";
import State from "./State";
import { searchReducer } from "./redux/searchLoans/reducer";
import { preApprovalsSearchReducer } from "./redux/searchPreApprovals/reducer";
import { HLHLContactRoleShape } from "./shared/LoggedInContainer/types";

// Known bug issue in immutability-helper package
// Fix to be released soon:
// https://github.com/kolodny/immutability-helper/pull/98
//
// import update from "immutability-helper";
const update: any = require("immutability-helper");

const initialState = new State();

const borrowerReducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case "UPDATE_APPLICATION":
      return update(state, {
        loanApplication: {
          $merge: action.payload,
        },
      });
    default: {
      return state;
    }
  }
};

const reduxFormReducer = formReducer.plugin({
  "new-message": (state, action) => {
    switch (action.type) {
      case PENDING_SEND_MESSAGE_SUCCESS:
        return undefined;
      default:
        return state;
    }
  },
});
/* combine & export */

export interface CombinedStateShape {
  borrower: State;
  events: EventsState;
  form: any;
  messages: any;
  modals: any;
  routing: any;
  operator: OperatorDashboardStateShape;
  operatorHomepage: any;
  trusOperators: GetTRUSOperatorsState;
  hlhlContactsRole: HLHLContactRoleShape;
}

export const combinedReducers = combineReducers({
  borrower: borrowerReducer,
  events: eventsReducer,
  queues: queuesReducer,
  form: reduxFormReducer,
  messages: messageReducer,
  modals: modalsReducer,
  routing: routerReducer,
  operator: underwriterDashboardReducer,
  operatorHomepage: searchReducer,
  preApprovals: preApprovalsSearchReducer,
  trusOperators: trusOperatorsReducer,
  hlhlContactsRole: hlhlContactsRoleReducer,
  worksheetEditor: worksheetEditorReducer, // TODO: jjw: scope under dashboard?
});
